<!-- 学生的information -->
<template>
  <div class="mentee-info">
    <div>
      <div class="mentee-info-left">
        <zlr-menu :menuList="menuList"></zlr-menu>
      </div>
      <div class="mentee-info-right">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
// components
import ZlrMenu from '_c/menu/menu'
export default {
  name: 'mentee-info',
  components: {
    ZlrMenu
  },
  data () {
    return {
      menuList: [
        {
          title: 'Basic Info & Package Info',
          name: 'mentee-info-basic'
        },
        {
          title: 'Educational info',
          name: 'mentee-info-education'
        },
        {
          title: 'Test Scores',
          name: 'mentee-info-test'
        },
        {
          title: 'Personal experience',
          name: 'mentee-info-personal-exp'
        },
        {
          title: 'Graduate Study Preference',
          name: 'mentee-info-preference'
        },
        {
          title: 'Research Plans',
          name: 'mentee-info-research'
        },
        {
          title: 'School projects',
          name: 'mentee-info-school'
        },
        {
          title: 'Internship experiences',
          name: 'mentee-info-internship'
        },
        {
          title: 'Extracurricular experience',
          name: 'mentee-info-extracurricular'
        },
        {
          title: 'Family info',
          name: 'mentee-info-family'
        }
      ]
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
